/* Libs */
import create from 'zustand';

/* Model */
import Products from 'Models/Products';

const [useProductsStore] = create((set, get) => ({
	products: null,
	fetchProducts: async () => {
		const response = await Products.fetch();
		console.log('set products', response);

		set({ products: response });
	},
	createProduct: async (params) => {
		const { products } = get();
		const response = await Products.create(params);
		console.log('new product', response);
		if (!response.error) {
			set({ products: [...products, response] });
		}
		return response;
	}
}));

export default useProductsStore;
